<div *ngIf="functionBlockFilterId">
    <pipelines id="fb-pipelines-table" [functionBlockFilterId]="functionBlockFilterId">
    </pipelines>
</div>